export default __webpack_public_path__ + "static/media/hero.dc6d0714.png";